import { authAxios } from "services";

export const fetchAll = (page) => authAxios().get(`/articles?page=${page}`);

export const create = (data) => authAxios().post(`/articles`, data);

export const fetchById = (id) => authAxios().get(`/articles/${id}`);

export const deleteById = (id) => authAxios().delete(`/articles/${id}`);

export const updateById = (id, data) => authAxios().post(`/articles/${id}?_method=PUT`, data);
